import { useEffect, useState } from "react";
import API from "../../services/api";

function FeatureManagement() {

    const [categories, setCategories] = useState([]);
    const [types, setTypes] = useState([]);
    const [features, setFeatures] = useState([]);

    const [categoryId, setCategoryId] = useState("");
    const [typeId, setTypeId] = useState("");

    const [featureName, setFeatureName] = useState("");
    const [optionValue, setOptionValue] = useState("");
    const [selectedFeature, setSelectedFeature] = useState(null);

    const fetchCategories = async () => {
        try {
            const res = await API.get("/api/categories");
            setCategories(res.data || []);
        } catch (err) {
            console.log(err);
        }
    };

    const fetchTypes = async (categoryId) => {
        try {
            const res = await API.get(`/api/types/${categoryId}`);
            setTypes(res.data || []);
        } catch (err) {
            console.log(err);
        }
    };

    const fetchFeatures = async (typeId) => {
        try {
            const res = await API.get(`/api/admin/features/${typeId}`);
            setFeatures(res.data || []);
        } catch (err) {
            console.log(err);
        }
    };

    const addFeature = async () => {

        if (featureName.trim() === "") return;

        try {

            if (typeId) {

                await API.post(
                    "/api/admin/feature-management/feature",
                    null,
                    {
                        params: {
                            name: featureName,
                            productTypeId: typeId
                        }
                    }
                );

            } else {

                await API.post(
                    "/api/admin/feature-management/feature",
                    null,
                    {
                        params: {
                            name: featureName,
                            categoryId
                        }
                    }
                );

            }

            setFeatureName("");

            fetchFeatures(typeId);

        } catch (err) {

            console.log(err);

        }

    };


    const deleteFeature = async (id) => {

        if (!window.confirm("Delete Feature?")) return;

        await API.delete(
            `/api/admin/feature-management/feature/${id}`
        );

        fetchFeatures(typeId);

    };

    const addOption = async () => {

        if (selectedFeature == null) return;

        if (optionValue.trim() === "") return;

        await API.post(
            "/api/admin/feature-management/option",
            null,
            {
                params: {
                    featureId: selectedFeature,
                    value: optionValue
                }
            }
        );

        setOptionValue("");

        setSelectedFeature(null);

        fetchFeatures(typeId);

    };

    const deleteOption = async (id) => {

        await API.delete(
            `/api/admin/feature-management/option/${id}`
        );

        fetchFeatures(typeId);

    };
    useEffect(() => {
        fetchCategories();
    }, []);

    return (
        <div className="container mt-4">

            <h2 className="mb-4">
                Feature Management
            </h2>

            <div className="row">

                <div className="col-md-4">

                    <label className="form-label">
                        Category
                    </label>

                    <select
                        className="form-control"
                        value={categoryId}
                        onChange={(e) => {

                            const id = e.target.value;

                            setCategoryId(id);
                            setTypeId("");
                            setFeatures([]);

                            fetchTypes(id);

                        }}
                    >

                        <option value="">
                            Select Category
                        </option>

                        {
                            categories.map(c => (

                                <option
                                    key={c.id}
                                    value={c.id}
                                >
                                    {c.name}
                                </option>

                            ))
                        }

                    </select>

                </div>

                <div className="col-md-4">

                    <label className="form-label">

                        Product Type

                    </label>

                    <select
                        className="form-control"
                        value={typeId}
                        disabled={!categoryId}
                        onChange={(e) => {

                            const id = e.target.value;

                            setTypeId(id);

                            fetchFeatures(id);

                        }}
                    >

                        <option value="">
                            Select Product Type
                        </option>

                        {

                            types.map(t => (

                                <option
                                    key={t.id}
                                    value={t.id}
                                >
                                    {t.name}
                                </option>

                            ))

                        }

                    </select>

                </div>

            </div>

            <hr />

            {

                typeId && (

                    <div className="card">

                        <div className="card-header">

                            <h5>

                                Features

                            </h5>

                        </div>

                        <div className="card-body">

                            {

                                features.length === 0 ?

                                    <p>

                                        No Features

                                    </p>

                                    :

                                    features.map(feature => (

                                        <div
                                            key={feature.id}
                                            className="border rounded p-3 mb-3"
                                        >

                                            <div className="d-flex justify-content-between">

                                                <h5>

                                                    {feature.name}

                                                </h5>

                                                <button
                                                    className="btn btn-danger btn-sm"
                                                    onClick={() => deleteFeature(feature.id)}
                                                >
                                                    Delete Feature
                                                </button>

                                            </div>

                                            <div className="mt-3">

                                                {feature.options && feature.options.length > 0 ? (

                                                    feature.options.map(option => (

                                                        <span
                                                            key={option.id}
                                                            className="badge bg-primary me-2 mb-2"
                                                        >

                                                            {option.optionValue}

                                                            <button
                                                                className="btn-close btn-close-white ms-2"
                                                                style={{ fontSize: "8px" }}
                                                                onClick={() => deleteOption(option.id)}
                                                            />

                                                        </span>

                                                    ))

                                                ) : (

                                                    <span className="text-muted fst-italic">
                                                        This is a text feature (No predefined options)
                                                    </span>

                                                )}

                                            </div>

                                            <div className="mt-3">

                                                <button
                                                    className="btn btn-success btn-sm me-2"
                                                    onClick={() => {

                                                        setSelectedFeature(feature.id);

                                                        const value = prompt("Option");

                                                        if (value) {

                                                            setOptionValue(value);

                                                            setTimeout(() => {

                                                                addOption();

                                                            }, 100);

                                                        }

                                                    }}
                                                >

                                                    Add Option

                                                </button>

                                                <button
                                                    className="btn btn-warning btn-sm"
                                                >

                                                    Edit Feature

                                                </button>

                                            </div>

                                        </div>

                                    ))

                            }

                            <div className="mt-4">

                                <input

                                    className="form-control"

                                    placeholder="Feature Name"

                                    value={featureName}

                                    onChange={(e) => setFeatureName(e.target.value)}

                                />

                                <button

                                    className="btn btn-primary mt-2"

                                    onClick={addFeature}

                                >

                                    Add Feature

                                </button>

                            </div>

                        </div>

                    </div>

                )

            }

        </div>
    );
}

export default FeatureManagement;